export default [
  {
    content: "벨트, 풀리 등의 위험 부위는 노출되어 있지 않은가?",
    isChecked: "",
    title: "동력 전달부",
  },
  {
    content: "볼트, 키 등의 고정구가 돌출되어 회전하지는 않는가?",
    isChecked: "",
    title: "동력 전달부",
  },
  {
    content: "조작 스위치(버튼)는 표시가 명확한가?",
    isChecked: "",
    title: "조작반",
  },
  {
    content: "시동(ON), 정지(OFF)장치의 기능은 확실한가?",
    isChecked: "",
    title: "조작반",
  },
  {
    content: "회전 날개에는 부식 및 마모가 없는가?",
    isChecked: "",
    title: "회전체",
  },
  {
    content: "주축 및 베어링부의 이상음, 진동 및 이상발열은 없는가?",
    isChecked: "",
    title: "회전체",
  },
  {
    content: "볼트의 풀림은 없는가?",
    isChecked: "",
    title: "회전체",
  },
  {
    content: "비상 정지 장치는 확실하게 작동하는가?",
    isChecked: "",
    title: "방호장치",
  },
  {
    content: "원심기에는 덮개나 울이 설치되어 있는가?",
    isChecked: "",
    title: "방호장치",
  },
  {
    content: "리미트 스위치가 설치되어 덮개나 울을 열면 기계는 멈추는가?",
    isChecked: "",
    title: "방호장치",
  },
  {
    content: "스위치 커버가 파손되지 않았는가?",
    isChecked: "",
    title: "전기계통",
  },
  {
    content: "전선의 연결상태가 앙호한가?",
    isChecked: "",
    title: "전기계통",
  },
  {
    content: "접지선이 연결되어 있는가?",
    isChecked: "",
    title: "전기계통",
  },
  {
    content: "배선의 피복에 손상된 부분은 없는가?",
    isChecked: "",
    title: "전기계통",
  },
  {
    content: "기계를 반드시 정지시키고 내용물에 접근하는가?",
    isChecked: "",
    title: "작업",
  },
  {
    content: "타력 회전을 손으로 정지시키지는 않는가?",
    isChecked: "",
    title: "작업",
  },
];
